// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"kndh8vW","sellerDetails":"kndh8vW","seller-name":"KIvEEhA","sellerName":"KIvEEhA","badge":"Rc5Ucrs","promoted-gig-text":"dfiUSlE","promotedGigText":"dfiUSlE"};